import {propertyEvent} from '@sinclair-digital/stl-common/src/analytics/util';

const labeledEvent = action => label => propertyEvent(true, action, {label});

export const viewSiteMap = labeledEvent('viewSiteMap');
export const publishSite = labeledEvent('publishSite');
export const unpublishSite = labeledEvent('unpublishSite');

export const focusOnPresentation = labeledEvent('focusOnPresentation');
export const changePresentation = labeledEvent('changePresentation');
export const savePresentation = labeledEvent('savePresentation');
export const publishPresentation = labeledEvent('publishPresentation');

export const addSection = (opts = {}) => propertyEvent(true, 'addSection', opts);
export const focusOnSection = labeledEvent('focusOnSection');
export const modifySeo = labeledEvent('modifySeo');
export const saveSection = labeledEvent('saveSection');
export const publishSection = labeledEvent('publishSection');
export const unpublishSection = labeledEvent('unpublishSection');

export const viewNavigation = labeledEvent('viewNavigation');
export const saveNavigation = labeledEvent('saveNavigation');

export const viewSettings = labeledEvent('viewSettings');
export const viewGeneralSettings = labeledEvent('viewGeneralSettings');
export const viewThemeSettings = labeledEvent('viewThemeSettings');
export const viewIntegrationSettings = labeledEvent('viewIntegrationSettings');
export const viewPackageTypeSettings = labeledEvent('viewPackageTypeSettings');
export const viewSourceSettings = labeledEvent('viewSourceSettings');
export const viewSocialSettings = labeledEvent('viewSocialSettings');
export const saveSettings = labeledEvent('saveSettings');
